import mock from './mock'

import './jwt'
import './select'
import './pages/faq'
import './apps/invoice'
import './apps/userList'
import './pages/profile'
import './pages/blog-data'
import './tables/datatables'
import './navbar/navbarSearch'
import './pages/knowledge-base'
import './apps/permissionsList'
import './cards/card-analytics'
import './cards/card-statistics'
import './pages/account-settings'
import './autoComplete/autoComplete'

mock.onAny().passThrough()
